import { format } from 'date-fns';
import { CommonUtilities } from '../../commonUtils';

export default class royContractServices {

    static associatedReleases(data: any) {
        var url = 'contracts/compilation/associatedReleases/withexclusion?' + CommonUtilities.buildQueryString(data, true, true);;
        return CommonUtilities.getData(url);;
    }

    static formatevaluation(contract: any, data: any) {
        var url = 'contracts/' + contract + '/formatevaluation?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static formatevaluationSave(contract: any, data: any) {
        var url = 'contracts/' + contract + '/formatevaluation';
        return CommonUtilities.postData(url, data);
    }
    static formatevaluationDelete(contract: any, id: any) {
        var url = 'contracts/' + contract + '/formatEvaluationId/'+id;
        return CommonUtilities.deleteData(url);
    }



    static ratesBasisPeriod(data: any) {
        var url = 'contracts/ratesBasisPeriod/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }
    static ratesBasisPeriodDelete(data: any) {
        var url = 'contracts/ratesBasisPeriod/delete' + data;
        return CommonUtilities.deleteData(url);
    }

    static ratesBasisPeriodSave(data: any) {
        var url = 'contracts/ratesBasisPeriod/save';
        return CommonUtilities.postData(url, data);;
    }
}